import { Component, Input } from "@angular/core";

@Component({
    selector: "logo-svg",
    templateUrl: "./logo.svg",
    styleUrls: ["./logo.svg.scss"],
    standalone: true
})

export class LogoSvgComponent {

@Input() size: number = 100;

    constructor() {

    }

}